/** @jsx h */
import { h } from 'preact'

const TimeIcon = ({
  style = {},
  fill = '#757575',
  stroke = '#757575',
  width = '14',
  height = '14',
  className = '',
  viewBox = '0 0 14 14'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_time-icon ${className}`}
    aria-hidden='true'
  >
    <g fill='none' stroke={stroke} strokeMiterlimit='10' strokeWidth='1'>
      <circle cx='7' cy='7' r='7' stroke='none' />
      <circle cx='7' cy='7' r='6.5' fill='none' />
    </g>
    <path d='M139.751,510.458l2.538,2.166,4.209-2.847-4.085,1.671Z' transform='translate(-135.5 -504.5)' fill={fill} />
  </svg>
)

export default TimeIcon
